import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import styles from "./redirect-to-setup.module.css"

@tagName("")
export default class RedirectToSetupComponent extends Component {
  readonly styles = styles
}
